import {
  Cancel as CancelIcon,
  CheckCircle as CheckCircleIcon,
  Pending as PendingIcon,
} from "@mui/icons-material";
import DescriptionIcon from "@mui/icons-material/Description";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { Chip } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { statusLabelsEnum } from "../utils/constants";
import { getStatusPaletteKey, resolverStatusSolicitacao } from "../utils/statusPalette";

export function getStatusChipSx(theme, paletteKey) {
  const isDark = theme.palette.mode === "dark";
  const isGrey = paletteKey === "grey" || !theme.palette[paletteKey]?.main;
  const paletteColor = isGrey ? null : theme.palette[paletteKey];
  const fill = paletteColor?.main ?? theme.palette.grey[isDark ? 400 : 500];
  const text = isGrey
    ? isDark
      ? theme.palette.grey[200]
      : theme.palette.grey[800]
    : isDark
      ? paletteColor.light
      : paletteColor.dark;

  return {
    height: 32,
    minWidth: 148,
    fontWeight: 600,
    letterSpacing: 0.2,
    borderRadius: "999px",
    backgroundColor: alpha(fill, isDark ? 0.24 : 0.14),
    color: text,
    border: "1px solid",
    borderColor: alpha(fill, isDark ? 0.75 : 0.45),
    "& .MuiChip-icon": {
      color: "inherit",
      marginLeft: "10px",
      marginRight: "4px",
      fontSize: "18px !important",
    },
    "& .MuiChip-label": {
      paddingLeft: "8px",
      paddingRight: "12px",
    },
  };
}

const StatusChip = ({ status }) => {
  const theme = useTheme();
  const statusNormalizado = resolverStatusSolicitacao(status);
  const paletteKey = getStatusPaletteKey(statusNormalizado);
  let icon;
  let label;

  switch (statusNormalizado) {
    case statusLabelsEnum.APROVADA:
      icon = <CheckCircleIcon />;
      label = "Aprovada";
      break;
    case statusLabelsEnum.REJEITADA:
      icon = <CancelIcon />;
      label = "Rejeitada";
      break;
    case statusLabelsEnum.ANALISTA_ANALISANDO:
      icon = <PendingIcon />;
      label = "Analista Analisando";
      break;
    case statusLabelsEnum.SOLICITANDO_INFORMACOES:
      icon = <NotificationsIcon />;
      label = "Aguardando Informações";
      break;
    case statusLabelsEnum.AGUARDANDO_PAGAMENTO:
      icon = <ScheduleIcon />;
      label = "Aguardando Pagamento";
      break;
    case statusLabelsEnum.AGUARDANDO_ANALISE:
      icon = <ScheduleIcon />;
      label = "Aguardando Análise";
      break;
    case statusLabelsEnum.LICENCA_EMITIDA:
      icon = <DescriptionIcon />;
      label = "Licença Emitida";
      break;
    case statusLabelsEnum.AGUARDANDO_APROVACAO:
      icon = <ScheduleIcon />;
      label = "Aguardando Aprovação";
      break;
    case statusLabelsEnum.CORRECAO:
      icon = <PendingIcon />;
      label = "Correção";
      break;
    case statusLabelsEnum.LICENCA_ASSINADA:
      icon = <CheckCircleIcon />;
      label = "Licença Assinada";
      break;
    case statusLabelsEnum.PAGAMENTO_EFETUADO:
      icon = <CheckCircleIcon />;
      label = "Pagamento Efetuado";
      break;
    case statusLabelsEnum.LICENCA_CANCELADA:
      icon = <CancelIcon />;
      label = "Licença Cancelada";
      break;
    default:
      icon = <PendingIcon />;
      label =
        typeof status === "string" ? status.replace(/_/g, " ") : "Desconhecido";
  }

  return (
    <Chip
      icon={icon}
      label={label}
      size="small"
      sx={getStatusChipSx(theme, paletteKey)}
    />
  );
};

export default StatusChip;
